import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import { auth } from "./modules/auth";
import { admin } from "./modules/admin";
import { alert } from "./modules/alert";
import { sales } from "./modules/sales";
import { agent } from "./modules/agent";
import { stats } from "./modules/stats";
import { passwords } from "./modules/passwords";
Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "data", // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  reducer: (state) => ({
    auth: state.auth,
  }),
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});
const store = new Vuex.Store({
  modules: {
    alert,
    auth,
    admin,
    sales,
    agent,
    stats,
    passwords,
  },
  plugins: [vuexLocalStorage.plugin],
});

export default store;
